import {combineReducers} from 'redux';
import accessibilityReducer from './accessibilityReducer';
import acknowledgedMessageReducer from './acknowledgedMessageReducer';
import addressReducer, {selectDeliveryAddress as fromSelectDeliveryAddress} from './addressReducer';
import amazonpay from './amazonpayReducer';
import arvato from './arvatoReducer';
import createAccount from './createAccountReducer';
import deliverySectionReducer from './deliverySectionReducer';
import deliveryOption from './deliveryOptionReducer';
import email from './emailReducer';
import expressCheckoutReducer from './expressCheckoutReducer';
import editBasketReducer from './editBasketReducer';
import giftcardReducer from './giftcardReducer';
import klarna from './klarnaReducer';
import langReducer from './langReducer';
import openpay from './openpayReducer';
import orderCompleteReducer from './orderCompleteReducer';
import orderSummary from './orderSummaryReducer';
import overlayReducer from './overlayReducer';
import pageMessageReducer from './pageMessageReducer';
import paymentReducer from './paymentReducer';
import pudo from './pudoReducer';
import siteReducer from './siteReducer';
import socialSharingReducer from './socialSharingReducer';
import spotii from './spotiiReducer';
import startReducer from './startReducer';
import themeReducer from './themeReducer';
import tooltipReducer from './tooltipReducer';
import uiReducer from './uiReducer';
import zippay from './zippayReducer';
import alipayPlus from './alipayPlusReducer';
import optty from './opttyReducer';
import recaptchaReducer from './recaptchaReducer';

const appReducer = combineReducers({
  lang: langReducer,
  site: siteReducer,
  start: startReducer,
  address: addressReducer,
  delivery: deliverySectionReducer,
  pudo,
  klarna,
  amazonpay,
  arvato,
  zippay,
  spotii,
  openpay,
  optty,
  alipayPlus,
  deliveryOption,
  payment: paymentReducer,
  acknowledgedMessage: acknowledgedMessageReducer,
  orderComplete: orderCompleteReducer,
  socialSharing: socialSharingReducer,
  orderSummary,
  overlay: overlayReducer,
  tooltip: tooltipReducer,
  pageMessage: pageMessageReducer,
  ui: uiReducer,
  accessibility: accessibilityReducer,
  theme: themeReducer,
  email,
  createAccount,
  expressCheckout: expressCheckoutReducer,
  recaptcha: recaptchaReducer,
  giftcard: giftcardReducer,
  editBasket: editBasketReducer,
});

export const selectDeliveryAddress = state => (
  fromSelectDeliveryAddress(state.address)
);

export default appReducer;
